<div class="cda-container">
    <app-table-component
        [data]="customerActivityList()"
        [columns]="tableColumns"
        [totalRecords]="totalRecords()"
        [rows]="rows"
        [first]="first"
        (pageChange)="onPageChange($event)"
        [customFilters]="[createdDateFilter]"
        [showSearch]="false"
        [showColumnSelector]="false"
        [showClearFilters]="false" />
</div>
